import { useEffect, useState } from "react";
import styles from "./ProfileForm.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { EditKidsProfileFormProps } from "modules/profile";
import { computeAge } from "utils/profile";
import { updateKidProfile } from "services/profileManegement/update-kid-Profile";
import ErrorFailed from "components/errorFailed/errorFailed";
import { smoothScrollPolyfill } from "utils/smoothScroll";



export default function EditKidProfileForm({ initialValues, buttonOptions = [], onSubmitSuccess }: EditKidsProfileFormProps) {
    const [formValues, setFormValues] = useState(initialValues);
    const [error, setError] = useState<string | null>(null);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        if (name === 'zip') {
            const numericValue = value.replace(/\D/g, '').slice(0, 5);
            setFormValues({
                ...formValues,
                [name]: numericValue,
            });
            return; 
        }
        setFormValues({
            ...formValues,
            [name]: name === 'birth_date' && value ? new Date(value) : value,
            age: name === 'birth_date' && value ? computeAge(new Date(value)) : formValues.age
        });
    };
    useEffect(() => {
        setFormValues(initialValues);
    }, [initialValues]);

    const handleSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
        if (e) e.preventDefault();
        const formElement = document.querySelector("form");
        if (formElement) {
            const firstInvalidElement = formElement.querySelector("input:invalid, select:invalid, textarea:invalid");
            if (firstInvalidElement) {
                
                const elementPosition = (firstInvalidElement as HTMLElement).getBoundingClientRect().top + window.scrollY;
    
                smoothScrollPolyfill(elementPosition -200, 1000);
                (firstInvalidElement as HTMLElement).focus();
                setError("Bitte füllen Sie alle erforderlichen Felder aus.");
                return false;
            }
        }
        const profileData = { ...formValues };
        try {
            const response = await updateKidProfile(profileData);

            if (response.success) {
                setError(null);
                if (onSubmitSuccess) {
                    onSubmitSuccess();
                }
            } else {
                setError(response.message);
                smoothScrollPolyfill(150, 1000);


            }
        } catch (error) {
            console.error("Fehler beim Aktualisiere eines Kindes daten:", error);
            setError("Fehler beim Aktualisiere eines Kindes daten: Ein Serverfehler ist aufgetreten.");
            smoothScrollPolyfill(150, 1000);


        }
    };

    return (
        <form onSubmit={handleSubmit} noValidate>
            {error && <ErrorFailed error={error} />}

            <section className={styles.section}>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="first_name">Vorname*</label>
                        <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            value={formValues.first_name}
                            readOnly={true}

                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="last_name">Nachname*</label>
                        <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            value={formValues.last_name}
                            readOnly={true}

                        />
                    </div>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="birth_date">Geburtsdatum*</label>
                        <input type="date"
                            id="birth_date"
                            name="birth_date"
                            value={
                                formValues.birth_date
                                    ? new Date(formValues.birth_date).toISOString().split('T')[0]
                                    : ""
                            }
                            onChange={handleInputChange} />
                    </div>
                    <div className={commonStyles.formGroupOld}>
                        <p>{formValues.age} Jahre</p>
                    </div>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="country">Land*</label>
                    <select
                        id="country"
                        name="country"
                        value={formValues.country}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="Deutschland">Deutschland</option>
                    </select>
                </div>
                <div className={commonStyles.formGroupRow}>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="zip">PLZ*</label>
                        <input
                            type="text"
                            id="zip"
                            name="zip"
                            value={formValues.zip}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className={commonStyles.formGroup}>
                        <label htmlFor="city">Stadt*</label>
                        <input
                            type="text"
                            id="city"
                            name="city"
                            value={formValues.city}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="street">Straße & Haus Nr.*</label>
                    <input
                        type="text"
                        id="street"
                        name="street"
                        value={formValues.street}
                        onChange={handleInputChange}
                        required
                    />
                </div>
            </section>
            <section className={styles.section}>
                <div className={styles.sectionTitle}>
                    <h3>Allergien und Krankheiten</h3>
                    <p>Bitte geben Sie Allergien und Krankheiten von Kind ein.</p>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="allergy_medication">Allergien & Medikamente</label>

                    <textarea
                        id="allergy_medication"
                        name="allergy_medication"
                        value={formValues.allergy_medication}
                        onChange={handleInputChange}
                        rows={3}
                    />
                </div>
            </section>
            <section className={styles.section}>
                <div className={styles.sectionTitle}>
                    <h3>Ergänzungen</h3>
                    <p>Bitte geben Sie Ihre weitere notiz ein.</p>
                </div>
                <div className={commonStyles.formGroup}>
                    <label htmlFor="note">Notiz</label>
                    <textarea
                        id="note"
                        name="note"
                        value={formValues.note}
                        onChange={handleInputChange}
                        rows={3}
                    />
                </div>
            </section>
            <div className={styles.buttonContainer}>
                <div className={styles.leftButton}>
                    {buttonOptions[0] && (
                        <button
                            type={buttonOptions[0].onClick ? "button" : "submit"}
                            className={`${commonStyles.commonButton} ${commonStyles.backButton}`}
                            onClick={buttonOptions[0].onClick}
                        >
                            {buttonOptions[0].label}
                            {buttonOptions[0].icon && (
                                <span className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`}>
                                    {buttonOptions[0].icon}
                                </span>
                            )}
                        </button>
                    )}
                </div>
                <div className={styles.rightButtons}>
                    {buttonOptions.slice(1).map((button, index) => (
                        <button
                            key={index}
                            type={button.onClick ? "button" : "submit"}
                            className={button.onClick ? `${commonStyles.commonButton} ${commonStyles.secondButton}` : `${commonStyles.commonButton} ${commonStyles.submitButton}`}
                            onClick={button.onClick}
                        >
                            {button.label}
                            {button.icon && (
                                <span className={`${commonStyles.commonButtonIcon} ${styles.buttonIcon}`}>
                                    {button.icon}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>
        </form>
    );
}
